import React from 'react';
import { VehicleRowData } from '@/types';
import { highlightAllText } from '@/utils/highlightText';

interface VehicleRowProps {
  vehicleData: VehicleRowData;
  onRemove: () => void;
  isSelected?: boolean;
  onSelectionChange?: (selected: boolean) => void;
  searchQuery?: string;
}

export const VehicleRow = React.memo<VehicleRowProps>(({ 
  vehicleData, 
  onRemove,
  isSelected = false,
  onSelectionChange,
  searchQuery = ''
}) => {
  const { modelName, vehicle, isDuplicate } = vehicleData;

  const rowClassName = `vehicle-row ${vehicle?.source === 'lua' ? 'lua-vehicle-row' : 'xml-vehicle-row'} ${isDuplicate ? 'duplicate-row' : ''} ${isSelected ? 'selected-row' : ''}`;

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onSelectionChange?.(event.target.checked);
  };

  // Highlight text if search query exists
  const displayedModelName = searchQuery ? highlightAllText(modelName, searchQuery) : modelName;
  const displayedBrand = searchQuery && vehicle?.brand ? highlightAllText(vehicle.brand, searchQuery) : vehicle?.brand;
  const displayedName = searchQuery && vehicle?.name ? highlightAllText(vehicle.name, searchQuery) : vehicle?.name;
  const displayedCategory = searchQuery && vehicle?.category ? highlightAllText(vehicle.category, searchQuery) : vehicle?.category;

  return (
    <tr className={rowClassName}>
      {/* Checkbox column */}
      <td className="checkbox-cell">
        <input
          type="checkbox"
          checked={isSelected}
          onChange={handleCheckboxChange}
          className="vehicle-checkbox"
          aria-label={`Select ${modelName}`}
        />
      </td>

      {/* Model column */}
      <td className={`model-cell ${isDuplicate ? 'duplicate' : ''}`} dangerouslySetInnerHTML={{ __html: displayedModelName }} />

      {/* Brand column */}
      <td className={vehicle?.brand ? 'lua-data' : 'xml-data'} dangerouslySetInnerHTML={{ __html: displayedBrand || '-' }} />

      {/* Name column */}
      <td className={vehicle?.name ? 'lua-data' : 'xml-data'} dangerouslySetInnerHTML={{ __html: displayedName || '-' }} />

      {/* Category column */}
      <td className={vehicle?.category ? 'lua-data' : 'xml-data'} dangerouslySetInnerHTML={{ __html: displayedCategory || '-' }} />

      {/* Price column */}
      <td className={`price-cell ${vehicle?.price ? 'lua-data' : 'xml-data'}`}>
        {vehicle?.price ? vehicle.price.toLocaleString() : '-'}
      </td>

      {/* Type column */}
      <td className={vehicle?.type ? 'lua-data' : 'xml-data'}>
        {vehicle?.type || '-'}
      </td>

      {/* Actions column */}
      <td>
        <button 
          onClick={onRemove}
          className="remove-btn"
          title={`Remove ${modelName} from group`}
          aria-label={`Remove ${modelName}`}
        >
          Remove
        </button>
      </td>
    </tr>
  );
});

VehicleRow.displayName = 'VehicleRow';